import { selectFromTeamMemberPaginatedDto } from '../../models';
import MemberQuery from './TeamMemberQuery';

export default selectFromTeamMemberPaginatedDto()
  .hasNextPage
  .totalCount
  .edges(b => b.node(MemberQuery))
  .toString();
